import React, { useEffect, useMemo, useState } from 'react'
import { pick, last } from 'lodash-es'
import { showNotification } from '@mantine/notifications'
import { Button, SelectMantine } from '@ow/comps'
import { updateTable } from '@vt/apis/lib-ex/v2/tables-def'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { useBindStore } from './BindProvider'
import SelectCal from './SelectCal'
import MixCal from './MixCal'

const Calculation = () => {
  const { tbData, clickedInfo, selectedIds, setSelectedIds } = useTbViewStore(
    (state) =>
      pick(state, ['tbData', 'clickedInfo', 'selectedIds', 'setSelectedIds'])
  )

  const { appId, tbsRaw: tbs, updateTbs } = useAppEx()
  const { bindTbId, isCalStandards, setIsCalStandards } = useBindStore(
    (state) => pick(state, ['bindTbId', 'isCalStandards', 'setIsCalStandards'])
  )

  const [calType, setCalType] = useState('sum')

  // 赋分值
  const [assignedInfo, setAssignedInfo] = useState([])

  const { clickedId, label } = clickedInfo

  const { fields = [] } =
    (bindTbId && tbs[Number(bindTbId)] && tbs[Number(bindTbId)]) || {}

  const init = () => {
    setIsCalStandards(false)
    setSelectedIds([])
    setAssignedInfo([])
  }
  const currentBindField = useMemo(() => {
    const obj = fields.find(
      (v) =>
        v.slug.indexOf(clickedId) > -1 && v.slug.indexOf('_otherSelect') === -1
    )

    return obj
  }, [clickedInfo, tbs, bindTbId, fields])

  // 指标以及绑定信息
  // 需判断勾选的指标绑定类型的问题，其他类型无法统计
  const selectedStandardInfo = useMemo(() => {
    const arr = tbData.filter((v) => selectedIds.includes(v.objectId))
    return arr.map((item) => {
      const obj = fields.find(
        (v) =>
          v.ownViewDef &&
          v.ownViewDef.isBindStandard &&
          v.slug.includes(item.objectId)
      )
      return { standard: item, field: obj }
    })
  }, [selectedIds, fields])

  const canSave = useMemo(() => {
    if (selectedStandardInfo.length === 0) {
      return false
    }

    const obj = selectedStandardInfo.find((v) => !v.field)
    if (obj) {
      return false
    }
    return true
  }, [selectedStandardInfo])

  // 用于计算和的保存
  const onSaveSumCodeField = () => {
    const slugs = selectedStandardInfo
      .map((v) => v.field)
      .filter((v) => v)
      .map((v) => v.slug)
      .join('/')

    const code = `function ac(params) {
    var slugs = "${slugs}".split('/')
    var data = params.rowData
    var sum = 0
    for (let i = 0; i <= slugs.length; i++) {
      sum += Number((data && data[slugs[i]]) || 0)
    }
    return sum
  }`

    const updateIndex = fields.findIndex(
      (e) => e.slug === currentBindField.slug
    )
    const arr = [...fields]
    arr.splice(updateIndex, 1, {
      ...currentBindField,
      ownViewDef: { ...currentBindField.ownViewDef, code },
      sumSlugs: slugs.split('/'), // 用于回显？？？？
    })

    updateTable(appId, bindTbId, { tbNodes: arr }).then(() => {
      updateTbs()
      showNotification({
        title: '操作成功',
      })
    })
  }

  const onSaveAssignedCodeField = () => {
    const _assignedInfo = JSON.stringify(assignedInfo)

    const code = `function ac(params) {
      var rowData = params.rowData
      var fields = params.fields
      var arr= ${_assignedInfo}
      console.log(arr, 'arr')
    
      var sum = 0
      arr.forEach((item) => {
        var slug = item.slug
        var options = item.options
        var field = fields.find((v) => v.slug === slug)
        console.log(field, 'arr')
        if (field && field.type === 'dropSelect') {
          var selects = (field.selects || []).filter((v) =>
            options.includes(v.slug)
          )
          console.log(selects, 'arr')
          var multiple = field.multiple
          if (multiple && rowData[slug]) {
            rowData[slug].forEach((f) => {
              var obj = selects.find((s) => s.slug === f)
              if (obj) {
                sum += Number(obj.selectedMark || 0)
              }
            })
          }
          if (!multiple && rowData[slug]) {
            var obj = selects.find((s) => s.slug === rowData[slug] || rowData[slug].includes(s.slug))
            if (obj) {
              sum += Number(obj.selectedMark || 0)
            }
          }
        }
      })
      return sum
    }`

    const updateIndex = fields.findIndex(
      (e) => e.slug === currentBindField.slug
    )
    const arr = [...fields]
    arr.splice(updateIndex, 1, {
      ...currentBindField,
      ownViewDef: { ...currentBindField.ownViewDef, code },
      sumSlugs: assignedInfo, // 用于回显？？？？
    })

    updateTable(appId, bindTbId, { tbNodes: arr }).then(() => {
      updateTbs()
      showNotification({
        title: '操作成功',
      })
    })
  }

  // 用于计算混合统计的保存
  const onSaveMixCodeField = () => {
    const codeSlugs = selectedStandardInfo
      .map((v) => v.field)
      .filter((v) => v && v.code)
      .map((v) => v.slug)
      .join('/')
    const otherSlugs = selectedStandardInfo
      .map((v) => v.field)
      .filter((v) => v && !v.code)
      .map((v) => v.slug)
      .join('/')

    const code = `function ac(params) {
    var otherSlugs = "${otherSlugs}".split('/')
    var codeSlugs = "${codeSlugs}".split('/')
    var data = params.rowData
    var sum = 0
    for (let i = 0; i <= otherSlugs.length; i++) {
      sum += Number((data && data[otherSlugs[i]]) || 0)
    }
    return { defaultSum: sum, codeSlugs }
  }`

    const updateIndex = fields.findIndex(
      (e) => e.slug === currentBindField.slug
    )
    const arr = [...fields]
    arr.splice(updateIndex, 1, {
      ...currentBindField,
      ownViewDef: { ...currentBindField.ownViewDef, code },
    })

    updateTable(appId, bindTbId, { tbNodes: arr }).then(() => {
      updateTbs()
      showNotification({
        title: '操作成功',
      })
    })
  }

  useEffect(() => {
    if (clickedId) {
      init()
    }
  }, [clickedId])

  if (!bindTbId) {
    return <div>在“绑定”标签页选择表单</div>
  }

  return (
    <div className="w-full h-full relative flex flex-col gap-2">
      <span className="text-red-500">
        <b>注意！！！请确保选择的统计指标都被绑定</b>
      </span>
      <div className="w-48 flex">
        <SelectMantine
          styles={{
            dropdown: {
              borderStyle: 'solid',
            },
          }}
          onChange={(e) => {
            init()
            setCalType(e)
          }}
          value={calType}
          options={[
            { value: 'mix', label: '混合统计（可统计求和与赋分值）' },
            { value: 'sum', label: '求和统计' },
            { value: 'select', label: '赋分值统计' },
          ]}
        />
      </div>
      <div className="w-full flex mb-2">
        {!isCalStandards && (
          <Button
            type="primary"
            disabled={!currentBindField}
            className="gap-2"
            onClick={() => {
              setIsCalStandards(true)
            }}
          >
            <span>开始统计指标-</span>
            <b style={{ fontSize: '14px' }} className="font-semibold">
              {last(label.split('-'))}
            </b>
            <span>的数据</span>
          </Button>
        )}
        {isCalStandards && (
          <Button type="primary" className="gap-2">
            <span>您正在统计指标为：</span>
            <b style={{ fontSize: '14px' }} className="font-semibold">
              {last(label.split('-'))}
            </b>
          </Button>
        )}
      </div>
      {isCalStandards && (
        <span className="text-red-500">
          <b>该指标将以以下指标的数据的之和作为显示总数</b>
        </span>
      )}
      <div
        className="w-full flex flex-col h-96 overflow-y-scroll"
        style={{ fontSize: '14px' }}
      >
        {calType === 'select' && (
          <SelectCal
            selectedStandardInfo={selectedStandardInfo}
            assignedInfo={assignedInfo}
            setAssignedInfo={setAssignedInfo}
          />
        )}
        {calType === 'mix' && (
          <MixCal
            selectedStandardInfo={selectedStandardInfo}
            assignedInfo={assignedInfo}
            setAssignedInfo={setAssignedInfo}
          />
        )}
        {calType === 'sum' && (
          <>
            {selectedStandardInfo.map((item, index) => {
              return (
                <div key={item.objectId}>
                  {index + 1}:{item.standard.title}
                  {!item.field && (
                    <span className="text-red-500">!!暂未绑定，请先绑定</span>
                  )}
                </div>
              )
            })}
          </>
        )}
      </div>
      {isCalStandards && (
        <div className="flex gap-2 w-full absolute bottom-0 justify-end">
          <Button
            type="primary"
            className="gap-2"
            disabled={!canSave}
            onClick={() => {
              if (calType === 'sum') {
                onSaveSumCodeField()
              } else if (calType === 'mix') {
                onSaveMixCodeField()
              } else {
                onSaveAssignedCodeField()
              }
            }}
          >
            保存
          </Button>
          <Button
            type="secondary"
            opacityType="sm"
            onClick={() => {
              setIsCalStandards(false)
              setSelectedIds([])
              // 取消勾选的数据
            }}
            className="dark:bg-darkTheme-800 dark:border-darkTheme-1100 dark:text-dark-200"
          >
            取消
          </Button>
        </div>
      )}
    </div>
  )
}

export default Calculation
